export type ErrorBody = {
  code?: number
  message: string
  httpStatusCode: number
}

export const reqError = (
  httpStatusCode: number,
  message: string,
  code?: number,
) => ({
  code,
  message,
  httpStatusCode,
})

export const isReqError = (httpStatusCode: number) => httpStatusCode >= 400

export enum HTTPStatusCodes {
  /** Bad request */
  BadRequest = 400,
  /** Internal server error */
  InternalServerError = 500,
  /** Service unavailable error */
  ServiceUnavailable = 503,
}

export enum ErrorCodes {
  /** System outage requiring page reload */
  System = 0,
}
